module.exports = "<div [class]=\"theme\">\r\n    <router-outlet></router-outlet>\r\n</div>"